var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"im-box",class:{ 'im-box-ar': _vm.lang === 'AR' }},[_c('div',{ref:"refContainer",attrs:{"id":"IM-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }